import { useEffect } from 'react';
import queryString from 'query-string';
import moment from 'moment';
import { MONTH_FORMAT } from 'utils/constants';

export const ALL_PROPERTIES = 'all';

export const toMonthDate = date => moment(date || undefined).clone().startOf('month');

export const rowsForSelectedMonth = (rows, year, month) =>
  (rows || []).filter(r => Number(r.year) === Number(year) && Number(r.month) === Number(month));

export const firstQueryValue = value => (Array.isArray(value) ? value[0] : value);

export const readPageFilters = search => {
  const parsed = queryString.parse(search || '');
  const propertyRaw = firstQueryValue(parsed.property);
  const packageRaw = firstQueryValue(parsed.servicePackage);
  const unitRaw = firstQueryValue(parsed.unit);
  const dateRaw = firstQueryValue(parsed.date);
  const viewRaw = firstQueryValue(parsed.view);
  const parsedMonth = dateRaw ? moment(dateRaw, MONTH_FORMAT, true) : null;
  const monthDate = parsedMonth && parsedMonth.isValid() ? parsedMonth.clone().startOf('month') : moment().startOf('month');
  return {
    propertyId: propertyRaw && propertyRaw !== ALL_PROPERTIES ? String(propertyRaw) : undefined,
    servicePackageId: packageRaw ? String(packageRaw) : undefined,
    unitId: unitRaw ? String(unitRaw) : undefined,
    monthDate,
    hasDate: !!(parsedMonth && parsedMonth.isValid()),
    view: viewRaw === 'table' ? 'table' : 'card',
  };
};

export const replaceSearch = (history, location, patch) => {
  if (!history || !location || !patch) return;
  const parsed = queryString.parse(location.search || '');
  const next = Object.assign({}, parsed);
  Object.keys(patch).forEach(key => {
    const value = patch[key];
    if (value == null || value === '' || value === ALL_PROPERTIES) {
      delete next[key];
    } else {
      next[key] = String(value);
    }
  });
  const unchanged =
    String(parsed.hostId || '') === String(next.hostId || '') &&
    String(parsed.property || '') === String(next.property || '') &&
    String(parsed.servicePackage || '') === String(next.servicePackage || '') &&
    String(parsed.unit || '') === String(next.unit || '') &&
    String(parsed.date || '') === String(next.date || '') &&
    String(parsed.view || '') === String(next.view || '');
  if (unchanged) return;
  const nextSearch = queryString.stringify(next);
  history.replace({ pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : '' });
};

export const buildTabHref = (to, search, hostId) => {
  const parsed = queryString.parse(search || '');
  const next = queryString.stringify({
    ...parsed,
    hostId: hostId || parsed.hostId || undefined,
  });
  return next ? `${to}?${next}` : to;
};

export const useSyncPageFilters = (history, location, patch) => {
  const property = patch && patch.property;
  const servicePackage = patch && patch.servicePackage;
  const unit = patch && patch.unit;
  const date = patch && patch.date;
  const view = patch && patch.view;
  useEffect(() => {
    replaceSearch(history, location, patch);
  }, [history, location, property, servicePackage, unit, date, view]);
};
